import { MdOutlineWhatsapp, MdOutlineQuestionAnswer } from 'react-icons/md';
import { FaWhatsapp } from 'react-icons/fa';

const WHATSAPP_URL = 'https://wa.me/447458107868';

const faqData = [
    {
        category: "Questions sur l'inscription et le compte",
        questions: [
            {
                q: 'Comment créer un compte vendeur sur la plateforme ?',
                a: 'Pour créer un compte vendeur, il vous suffit de remplir vos coordonnées bancaires et de compléter le processus KYC (Know Your Customer). Cela permettra de valider votre compte et de commencer à vendre des leads.',
            },
            {
                q: 'Quels documents sont nécessaires pour valider mon compte vendeur ?',
                a: 'Pour valider votre compte vendeur, vous devrez fournir vos coordonnées bancaires ainsi que compléter le processus KYC, qui peut inclure la vérification de votre identité et de votre entreprise.',
            },
            {
                q: "Y a-t-il des frais d'inscription ?",
                a: "Non, il n'y a aucun frais d'inscription pour devenir vendeur sur la plateforme.",
            },
            {
                q: 'Comment modifier mes informations de compte (email, coordonnées bancaires, etc.) ?',
                a: 'Vous pouvez modifier vos informations dans la section "Mon compte" de votre espace personnel.',
            },
        ],
    },
    {
        category: 'Questions sur la vente de leads',
        questions: [
            {
                q: 'Comment puis-je proposer mes services ou produits sur la plateforme ?',
                a: 'Pour proposer vos services ou produits, il vous suffit de créer de nouvelles offres de leads ou de vous positionner sur des offres existantes.',
            },
            {
                q: 'Quelles informations dois-je fournir pour créer une offre de vente de leads ?',
                a: 'Lorsque vous créez une nouvelle offre, vous devrez fournir des informations détaillées sur les leads que vous vendez, y compris les critères de ciblage et le prix. Cela permettra aux acheteurs de mieux comprendre ce que vous proposez.',
            },
            {
                q: 'Comment déterminer le prix de mes leads ?',
                a: "Le prix des leads est entièrement à la discrétion du vendeur. Cependant, vous pouvez consulter la section \"Benchmark\" pour vous informer des prix pratiqués par d'autres vendeurs sur la plateforme et ainsi ajuster vos tarifs en conséquence.",
            },
            {
                q: 'Quelle est la quantité minimale ou maximale de leads que je peux vendre ?',
                a: 'Pour chaque offre, la quantité minimale de leads que vous pouvez vendre est de 50, tandis que la quantité maximale est de 500.',
            },
            {
                q: 'Puis-je vendre des leads provenant de sources externes ou uniquement de ma propre base de données ?',
                a: "Les leads doivent provenir de vos propres sources ou bases de données. Les sources externes sont acceptées à condition qu'elles respectent les critères de qualité de la plateforme.",
            },
            {
                q: 'Quelles garanties de qualité suis-je censé offrir sur les leads que je vends ?',
                a: 'Il est de votre responsabilité de garantir la qualité et la conformité des leads que vous vendez. La plateforme peut prendre des mesures en cas de plaintes sur la qualité des leads.',
            },
        ],
    },
    {
        category: "Questions sur l'intégration et la gestion des leads",
        questions: [
            {
                q: 'Comment intégrer mes leads à la plateforme ?',
                a: "L'intégration de vos leads à la plateforme se fait de deux manières : soit via votre landing page, soit via un Google Sheet où vous pouvez facilement importer vos leads.",
            },
            {
                q: "Est-ce que la plateforme offre des outils pour automatiser l'envoi des leads ?",
                a: "Oui, la plateforme automatise l'ensemble des envois de leads, vous permettant ainsi de gagner du temps et de simplifier la gestion de vos transactions.",
            },
            {
                q: 'Est-ce que je reçois des notifications lorsque mes leads sont achetés ?',
                a: "Oui, à chaque fois qu'un lead est acheté sur la plateforme, vous recevez une notification dans votre espace personnel pour vous informer de la vente.",
            },
        ],
    },
    {
        category: 'Questions sur les paiements et commissions',
        questions: [
            {
                q: 'Comment fonctionne le système de paiement sur la plateforme ?',
                a: 'Le système de paiement fonctionne de la manière suivante : à partir du début de votre mission, vous devez attendre 10 jours ouvrés avant de recevoir votre premier paiement. Une fois ce délai passé, vous serez payé tous les jours, au coût unitaire par lead que vous envoyez.',
            },
            {
                q: 'Quels sont les modes de paiement acceptés pour les transactions ?',
                a: 'Les modes de paiement acceptés sont le virement bancaire et la carte bancaire (CB).',
            },
            {
                q: 'Quand et comment serai-je payé pour les leads que je vends ?',
                a: 'Vous serez payé automatiquement tous les jours pour les leads que vous avez envoyés, à compter de la fin du délai de 10 jours ouvrés après le début de votre mission.',
            },
        ],
    },
    {
        category: 'Questions sur la protection et la sécurité',
        questions: [
            {
                q: 'Comment la plateforme protège-t-elle les données personnelles des leads ?',
                a: 'La plateforme respecte les normes de sécurité et de protection des données en vigueur. Toutes les données des leads sont traitées conformément à la réglementation applicable. Cependant, la responsabilité de la collecte et du traitement des données personnelles repose entièrement sur le vendeur. Tous les vendeurs doivent être conformes à la législation européenne, notamment en ce qui concerne la collecte des leads et le respect du RGPD.',
            },
            {
                q: "Que faire si je suspecte une fraude concernant l'achat ou la vente de leads ?",
                a: 'Si vous suspectez une fraude, nous vous conseillons de contacter immédiatement le support client pour résoudre la situation.',
            },
        ],
    },
];

const SellerAssistancePage = () => {
    return (
        <div className="mx-auto w-full max-w-6xl px-1 pb-6">
            {/* WhatsApp hero */}
            <div className="relative overflow-hidden rounded-2xl bg-leadrs-green-focus px-8 py-10">
                <div className="absolute -right-10 -top-10 h-48 w-48 rounded-full bg-white opacity-5" />
                <div className="absolute -bottom-8 -left-8 h-36 w-36 rounded-full bg-white opacity-5" />
                <div className="relative flex flex-col items-center gap-5 text-center">
                    <FaWhatsapp className="h-16 w-16 text-white" />
                    <div>
                        <h1 className="font-crimson text-3xl font-semibold text-white md:text-4xl">
                            Une question ? On est là.
                        </h1>
                        <p className="mx-auto mt-3 max-w-lg font-geist text-sm leading-relaxed text-white opacity-80">
                            Notre équipe répond directement sur WhatsApp. Parlez-nous de votre activité, de vos offres ou de tout problème technique — nous vous répondons rapidement.
                        </p>
                    </div>
                    <button
                        className="flex items-center gap-2 rounded-xl bg-white px-6 py-3 font-geist text-sm font-semibold text-leadrs-green-focus hover:opacity-90 transition-opacity"
                        onClick={() => window.open(WHATSAPP_URL, '_blank')}
                    >
                        <MdOutlineWhatsapp className="h-5 w-5" />
                        Nous contacter sur WhatsApp
                    </button>
                </div>
            </div>

            {/* FAQ */}
            <div className="mt-8">
                <div className="mb-5 flex items-center gap-3">
                    <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg bg-leadrs-yellow-soft">
                        <MdOutlineQuestionAnswer className="h-4 w-4 text-leadrs-yellow-focus" />
                    </div>
                    <div>
                        <h2 className="font-geist text-lg font-semibold text-leadrs-text">Foire Aux Questions</h2>
                        <p className="font-geist text-xs text-leadrs-text-soft">Retrouvez les réponses aux questions les plus fréquentes.</p>
                    </div>
                </div>

                <div className="space-y-4">
                    {faqData.map((section, idx) => (
                        <div key={idx} className="rounded-xl border border-leadrs-stroke bg-white px-5 py-5">
                            <div className="mb-4 flex items-center gap-3 border-b border-leadrs-stroke pb-3">
                                <h3 className="font-geist text-sm font-semibold text-leadrs-text">
                                    {section.category}
                                </h3>
                                <span className="ml-auto rounded-full bg-leadrs-bg px-2.5 py-1 font-geist text-xs font-medium text-leadrs-text-soft">
                                    {section.questions.length} questions
                                </span>
                            </div>
                            <div className="space-y-2">
                                {section.questions.map((item, qIdx) => (
                                    <details
                                        key={qIdx}
                                        className="group rounded-xl border border-leadrs-stroke bg-leadrs-bg px-4 py-3 transition-colors hover:border-leadrs-text-soft"
                                    >
                                        <summary className="cursor-pointer list-none font-geist text-sm font-semibold text-leadrs-text">
                                            <div className="flex items-center justify-between gap-3">
                                                <span>{item.q}</span>
                                                <span className="flex-shrink-0 text-leadrs-text-soft transition-transform group-open:rotate-45">+</span>
                                            </div>
                                        </summary>
                                        <p className="mt-2 font-geist text-sm leading-relaxed text-leadrs-text-soft">
                                            {item.a}
                                        </p>
                                    </details>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Bottom WhatsApp nudge */}
            <div className="mt-6 flex items-center justify-between rounded-xl border border-leadrs-green-soft bg-leadrs-green-soft px-5 py-4">
                <div className="flex items-center gap-3">
                    <MdOutlineWhatsapp className="h-5 w-5 text-leadrs-green-focus" />
                    <p className="font-geist text-sm font-medium text-leadrs-green-focus">
                        Vous n'avez pas trouvé votre réponse ?
                    </p>
                </div>
                <button
                    className="flex items-center gap-2 rounded-xl bg-leadrs-green-focus px-4 py-2 font-geist text-xs font-semibold text-leadrs-green-soft hover:opacity-80 transition-opacity"
                    onClick={() => window.open(WHATSAPP_URL, '_blank')}
                >
                    <MdOutlineWhatsapp className="h-4 w-4" />
                    WhatsApp
                </button>
            </div>
        </div>
    );
};

export default SellerAssistancePage;
